const PRODUCTION_API_DEFAULT =
  'https://ineedcarbonbuckets-5939a85366e1.herokuapp.com'

/** True when the SPA is opened on a machine-local host (dev or local prod preview). */
export function isLocalFrontendHost(): boolean {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  return h === 'localhost' || h === '127.0.0.1' || h === '0.0.0.0'
}

/**
 * Backend base URL when REACT_APP_API_URL is not set.
 * Uses localhost:8083 for local browsing so auth and SSE hit the same server
 * (127.0.0.1 vs localhost mismatch previously sent streams to Heroku while auth used :8083).
 */
export function getDefaultApiBaseUrl(): string {
  if (typeof window !== 'undefined' && isLocalFrontendHost()) {
    return 'http://localhost:8083'
  }
  return PRODUCTION_API_DEFAULT
}

export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL || getDefaultApiBaseUrl()
}
